/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Mode_CreateInputs */

const cs_sreality_seller_mode_create = /** @type {(inputs: Sreality_Seller_Mode_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Založit nového makléře`)
};

const en_sreality_seller_mode_create = /** @type {(inputs: Sreality_Seller_Mode_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new seller`)
};

/**
* | output |
* | --- |
* | "Create new seller" |
*
* @param {Sreality_Seller_Mode_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_mode_create = /** @type {((inputs?: Sreality_Seller_Mode_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Mode_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_mode_create(inputs)
	return cs_sreality_seller_mode_create(inputs)
});